const envSettings = window as any;

export const ENV_CONFIG = {
    CLIENT_ID: envSettings.REACT_APP_CLIENT_ID || '',
    REDIRECT_URI: envSettings.REACT_APP_REDIRECT_URI || '',
    AUTHORITY: envSettings.REACT_APP_AUTHORITY || '',
    API_URL: envSettings.REACT_APP_API_URL || ''
};
